export const VMS_COLORS = {
  primary: "#0B7A20",
  primaryDark: "#09671A",
  accent: "#16A34A",
  bg: "#F1F3F5",
  bgDeep: "#E7ECEF",
  cardBg: "#FFFFFF",
  border: "#DDE1E6",
  textMuted: "#6B7280",
};

export const VMS_BRAND = {
  appName: "Muhammadu Buhari House",
  subtitle: "Katsina State Government",
};
